<template>
    <div class="fzg-chuangtou-pc">
      <div class="fzg-banner">
        <fzg-menu/>
        <div class="sologan"></div>
      </div>

      <div class="ct-intro">
        <img class="tou-title" src="../../assets/img2/pc/chuangtou/title-ct.png" alt="">
        <div class="tou-intro">
          <!-- <p>小饭桌创投（原：凡创资本）是凡卓集团旗下直投基金。 </p>
          <p>自2018年成立以来，小饭桌创投坚持投资于为社会创造真实价值的早期创业企业，陪伴创业者从平凡到卓越。投资领域主要是 <span class="yellow">新经济领域以及国家战略性产业（如工业科技、新科技、新能源、生物医药等）</span>，投资案例包含企迈云商、E签宝、保碧新能源、欣旺达、增广智能、红云生物、脉络能源等。</p>
          <p>小饭桌创投管理资金规模超10亿元人民币，出资方来自头部互联网公司及各地方政府。依托于凡卓集团领先的创投生态体系，依靠团队专业的认知、筛选与决策，充分链接产业龙头、地方政府、高校人才及创业公司资源，落实返投政策，协助优质项目落地。</p> -->

          <p>小饭桌创投（原：凡创资本）是凡卓集团旗下直投基金。</p>
          <p>自2018年成立以来，小饭桌创投坚持投资于为社会创造真实价值的早期创业企业，陪伴创业者从平凡到卓越。投资领域主要是 <span class="yellow">新经济领域以及国家战略性产业（如工业科技、新科技、新能源、生物医药等）</span>，投资案例包含企迈科技、E签宝、圈量科技、爱数智慧、保碧新能源、禾电科技、1号职场、inse、中科氢易、脉络能源、大方智能、增广智能等。</p>
          <p>小饭桌创投聚焦早期科技投资，管理基金规模逾15亿人民币。投资团队来自北大、清华、人大、LSE等知名高校，拥有丰富的早期投资经验。</p>

        </div>
        <div class="tou-list">
          <div class="tou-item">
            <img class="logo" src="../../assets/img2/pc/chuangtou/icon1.png" alt="">
            <div class="name">基金定位</div>
            <div class="content">
              以小饭桌创投生态为基础<br>
              以地方优势产业为引导
            </div>
          </div>

          <div class="tou-item">
            <img class="logo" src="../../assets/img2/pc/chuangtou/icon2.png" alt="">
            <div class="name">投资策略</div>
            <div class="content">
              围绕前沿技术<br>
              聚焦大健康、先进制造、<br>
              新能源新材料领域
            </div>
          </div>

          <div class="tou-item">
            <img class="logo" src="../../assets/img2/pc/chuangtou/icon3.png" alt="">
            <div class="name">基金优势</div>
            <div class="content">
              聚焦早期投资（种子～Pre-A）<br>
              单笔金额500-1000万人民币
            </div>
          </div>

          <div v-if="false" class="tou-item">
            <img class="logo" src="../../assets/img2/pc/chuangtou/icon4.png" alt="">
            <div class="name">管理细则</div>
            <div class="content">
              政府全额出资，管理费用落地后置<br>
              Carry市场化分成
            </div>
          </div>
        </div>
      </div>

      <div class="fzg-ct-case-list">
        <img class="case-title" src="../../assets/img2/pc/chuangtou/title-al.png" >
        <ul class="bus-wrap">
          <li class="bus-item" v-for="item in invest_case_list">
            <div class="cover">
              <div class="cover-content"> {{ item.brief }} </div>
            </div>
            <img class="logo" :src="item.logo" alt="">
            <div class="name">{{ item.name }}</div>
          </li>
          <template v-if="false">
            <li class="bus-item">
              <div class="cover">
                <div class="cover-content"> 新一代经营门店经营系统，助力商家数字化升级 </div>
              </div>
              <img class="logo" src="../../assets/img2/pc/chuangfu/logo10.png" alt="">
              <div class="name">人才对接</div>
            </li>
          </template>
        </ul>

      </div>

      <!-- 公司列表 -->
      <div class="fzg-company-list">
        <div class="company-list-title">
          <img src="../../assets/img2/pc/chuangtou/title-bt.png" alt="">
        </div>
        <div class="fzg-company-list-wrap">
          <div class="fzg-company-list-item-wrap"
            v-for="(item,index) in invest_company_list"
            v-if="isShowMoreCompany ? true : index < 7"
            :class="{ 'active-company' : activeCompanyId == item.id}">
            <div class="fzg-citem"
              @click="activeCompanyId = item.id">
              <div class="citem-name">
                <div class="c-title"> {{item.name}} </div>
                <img class="right-icon" v-if="activeCompanyId == item.id" src="../../assets/img2/pc/chuangtou/icon-close.png">
                <img class="right-icon" v-else src="../../assets/img2/pc/chuangtou/icon-add.png">
              </div>
              <div class="c-item-content">
                <div class="c-item-image">
                  <img :src="item.logo" >
                </div>
                <div class="c-item-intro">
                  <p>{{item.brief }}</p>
                  <div class="c-item-link">
                    <a :href="item.link" target="_blank"> 查看企业 </a>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isShowMoreCompany" class="check-more" @click="isShowMoreCompany = true"> 更多 </div>
        </div>

      </div>

    </div>
</template>

<script>

import util from '../../assets/js/util'
import FzgMenu from '../common/FzgMenu.vue'

export default{
    components:{
      FzgMenu
    },
    props:[''],
    data(){
      return {
        invest_case_list: [],
        invest_company_list: [],
        activeCompanyId: 1,
        isShowMoreCompany: false,
      }
    },
    methods:{
      getInvestCaseList() {
        var self = this
        util.resource({
            url: '/api/fzg/invest_cases/',
            method: 'get',
            data: {
              n: 200
            },
            success (res) {
              if (res.code == 200) {
                self.invest_case_list = res.data.list
              }
            }
        })
      },
      // invested_company
      getInvestCompanyList() {
        var self = this
        util.resource({
            url: '/api/fzg/invested_company/',
            method: 'get',
            success (res) {
              if (res.code == 200) {
                self.invest_company_list = res.data.list
                if (self.invest_company_list.length > 0) {
                  self.activeCompanyId = self.invest_company_list[0].id
                }
              }
            }
        })
      },
    },
    mounted(){
      this.getInvestCaseList()
      this.getInvestCompanyList()
    },
    watch: {
    },

}
</script>

<style lang="scss">
.fzg-chuangtou-pc {
  .fzg-banner {
    // border: 1px solid red;
    // background: url(../../assets/img2/pc/chuangtou/banner.png) no-repeat;
    // background: url(https://static-image.xfz.cn/1686266423456/ct-bn.png) no-repeat;
    background: url(https://static-image.xfz.cn/1687734774650/investment_banner.png) no-repeat;
    background-size: auto;
    background-position: bottom;
    height: 340px;
    position: relative;
    .sologan {
      width: 100%;
      height: 95px;
      background-image: url(../../assets/img2/pc/chuangtou/sologan.png);
      background-repeat: no-repeat;
      background-size: auto 100%;
      background-position: center;
      color: white;
      // border: 1px solid red;
      margin: 60px auto;
    }
  }

  .ct-intro{
    // border: 1px solid green;
    height: 750px;
    margin: 60px auto 0;
    position: relative;
    .tou-title {
      // border: 1px solid #ce262f;
      width: 200px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 0px;
      margin-left: -100px;
    }
    .tou-intro {
      // border: 1px solid #ce262f;
      width: 1000px;
      height: 550px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 140px;
      text-align: left;
      margin-left: -500px;
      color: #575758;
      font-size: 16px;
      text-align: justify;
      .num {
        color: #d7ad78;
        font-size: 24px;
      }
      .yellow {
        color: #d7ad78;
      }
      p {
        margin-bottom: 15px;
      }
    }
    .tou-list {
      // border: 1px solid #ccc;
      position: absolute;
      width: 800px;
      height: 240px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-left: -400px;
      left: 50%;
      top: 390px;
      .tou-item {
        text-align: center;
        width: 240px;
        background-color: #f5f5f5;
        .logo {
          margin-top: 38px;
          width: 60px;
        }
        .name {
          margin-top: 10px;
          font-size: 18px;
          font-weight: bold;
          letter-spacing: 0px;
          color: #ce262f;
        }
        .content {
          margin-top: 15px;
          font-size: 13.5px;
          color: #444444;
        }
      }
    }
  }

  .fzg-ct-case-list {
    // border: 1px solid green;
    // background: #f6f9ff;
    padding-top: 80px;
    padding-bottom: 40px;
    position: relative;
    .case-title {
      // border: 1px solid red;
      width: 160px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 0;
      margin-left: -500px;
    }
    .bus-wrap {
      display: flex;
      // justify-content: space-between;
      flex-wrap: wrap;
      margin: 60px auto 20px;
      // border: 1px solid red;
      width: 1000px;
      border-collapse: collapse;
      // border-spacing: 4px;
      .bus-item {
        border: 1px solid #ededed;
        list-style-type: none;
        text-align: center;
        height: 200px;
        width: 200px;
        margin-left: -1px;
        position: relative;
        .logo {
          margin-top: 40px;
          // border: 1px solid #ccc;
          height: 90px;
        }
        .name {
          // border: 1px solid #ccc;
          margin-top: 10px;
          font-size: 16px;
          color: #444444;
        }
        .cover {
          visibility: hidden;
          opacity: 0;
          position: absolute;
          transition: visibility 0s, opacity 0.36s linear;
          border-radius: 2px;
          text-align: left;
          height: 100%;
        }

        &:hover {
          cursor: pointer;
          .cover {
            position: absolute;
            visibility: visible;
            width: 100%;
            height: 100%;
            background-color: #ad2027;
	          opacity: 0.87;
            display: flex;
            align-items: center;
            .cover-content {
              // border: 1px solid #ccc;
              font-size: 14px;
              padding: 20px;
              color: white;
            }
          }
        }
      }
      .bus-item:nth-child(n + 6) {
        margin-top: -2px;
      }
    }
  }

  .fzg-company-list {
    overflow: auto;
    // border: 1px solid green;
    position: relative;
    // margin-top: 100px;
    .company-list-title {
      // border: 1px solid red;
      width: 160px;
      position: absolute;
      left: 50%;
      right: 0;
      top: 50px;
      margin-left: -500px;
      img {
        width: 160px;
      }
    }
    .fzg-company-list-wrap {
      margin-top: 160px;
      margin-bottom: 100px;
      .fzg-company-list-item-wrap {
        // border: 1px solid green;
        margin: 0px auto 0;
        width: 1000px;
        .fzg-citem {
          border-bottom: 1px solid #ccc;
          cursor: pointer;
          .citem-name {
            background: white;
            padding: 15px;
            .c-title{
              // border: 1px solid red;
              display: inline-block;
              color: #424242;
              font-size: 16px;
              width: 820px;
              margin-left: 80px;

              white-space:nowrap;
              overflow:hidden;
              text-overflow: ellipsis;
            }
            .right-icon {
              width: 24px;
              float: right;
              vertical-align: text-top;
              margin-right: 5px;
              cursor: pointer;
            }
          }
          .c-item-content {
            // display: none;
            opacity: 0;
            overflow: hidden;
            height: 0px;
            // transition: height 0.3s ease-in, opacity .2s linear;
            transition: height 0.3s ease, opacity .4s linear;
            .c-item-image {
              // border: 1px solid #ccc;
              display: inline-block;
              margin-top: 30px;
              margin-bottom: 30px;
              overflow: hidden;
              width: 300px;
              img {
                // border: 1px solid #ccc;
                display: block;
                margin: 0 auto;
                width: 200px;
              }
            }
            .c-item-intro {
              // border: 1px solid #ccc;
              display: inline-block;
              vertical-align: top;
              width: 660px;
              padding: 20px;
              font-size: 14px;
              line-height: 1.8;
              color: #898989;
              text-align: justify;
              white-space: break-spaces;
              .c-item-title {
                font-size: 16px;
                color: #444444;
                margin-bottom: 10px;
              }
              .c-item-link{
                font-size: 14px;
                color: #444444;
                border :1px solid #ccc;
                display: inline-block;
                padding: 2px 25px;
                border-radius: 20px;
                margin-top: 20px;
                margin-left: -5px;
                font-size: 15px;
              }
            }
          }

        }
          &:first-child { // last fzg-citem
            border-top: 1px solid #ccc;
          }
      }
      .check-more {
        width: 120px;
        margin: 40px auto 0;
        border: 1px solid #ccc;
        text-align: center;
        padding: 6px 0;
        border-radius: 20px;
        cursor: pointer;
      }

      .active-company {
        .citem-name {
          background:#444444 !important;
          .c-title{
            color: white !important;
          }
        }
        .c-item-content {
          opacity: 1 !important;
          display: block !important;
          height: auto !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// FzgChuangTouPc.vue?49fd6dd4